import StatusPill from "@/components/ui/status-pill";
import {
  getSimulationModeHue,
  getSimulationModeLabel,
} from "@/lib/simulationMode";

/**
 * A session's or assignment's mode (Scored / Live Mic / Practice) as a pill.
 * The label and hue come from lib/simulationMode, the same ones
 * ModeTypeHeader colours the results list with, so a mode reads the same on
 * every surface. `mode` is a result mode ("LIVE" | "LIVE_MIC" | "PRACTICE");
 * for a role play pass `getRolePlayMode(rolePlay)`. `label` replaces the text
 * only when it adds a fact to the mode ("Scored · 80%" via
 * getRolePlayModeLabelWithScore). Size and look are StatusPill's.
 */
export default function ModePill({
  mode,
  label,
  size = "sm",
  variant = "soft",
  className,
}) {
  return (
    <StatusPill
      tone={getSimulationModeHue(mode)}
      label={label ?? getSimulationModeLabel(mode)}
      size={size}
      variant={variant}
      className={className}
    />
  );
}
